import { Component, OnInit } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { I18nService } from "src/app/service/i18n.service";
import { UtilService } from "src/app/service/util.service";
import { mortProviderValidator } from "../validators/mortgage_provider.validator";


@Component({
    selector: 'mortgage-provider',
    templateUrl: './mortgage_provider.component.html',
    styleUrls: ['./mortgage_provider.component.less']
})

export class MortgageProviderComponent implements OnInit {
    mortgageProvider: Array<string> = new Array<string>();
    mortProviderFrmGrp: FormGroup;
    prequalObj: any;
    mortgageProviderValue: string;

    constructor(private util: UtilService,
        private i18nService: I18nService, private router: Router, private _activatedRoute: ActivatedRoute) {
        this.util.sidebarTitle.next('slideTitles.mortgageDetails');
        this.prequalObj = this.util.getSessionStorage();
        console.log("prequal from provider", this.prequalObj);
    }

    ngOnInit(): void {
        this.createProvider();
        this.createFormGrp();
    }

    createProvider() {
        this.mortgageProvider = new Array<string>();
        this.mortgageProvider = ['Bank of Montreal', 'Bank of Nova Scotia', "National Bank of Canada", "Royal Bank of Canada",
            "Toronto-Dominion Bank", "ATB", "B2B Bank", "Desjardins", "Equitable Bank", "First National Financial", "Home Trust Company",
            "Manulife", "MCAP", "Nesto", "Sun Life", "Tangerine", "True North Mortgage", "Van City", "Not Listed"]
    }
    createFormGrp() {
        this.mortProviderFrmGrp = new FormGroup({
            provider: new FormControl('', [Validators.required]),
            isNotInList: new FormControl(false),
            enteredProvider: new FormControl('', [mortProviderValidator])
        })
        this.mortProviderFrmGrp.valueChanges.subscribe(obj => {
        })
        this.mortProviderFrmGrp.get('provider').valueChanges.subscribe(obj => {
            if (obj !== 'Not Listed') {
                this.mortgageProviderValue = obj;
            }
            this.mortProviderFrmGrp.get('enteredProvider').setValue('');
            let isNotInList = (obj === 'Not Listed') ? true : false;
            this.mortProviderFrmGrp.get('isNotInList').setValue(isNotInList, { emitEvent: false });
            if (isNotInList) {
                this.mortProviderFrmGrp.get('enteredProvider').setValue('', { emitEvent: false });
            }
        })
    }

    onContinue() {
        if (this.mortProviderFrmGrp.controls.enteredProvider.value.length !== 0) {
            this.mortgageProviderValue = this.mortProviderFrmGrp.controls.enteredProvider.value
        }
        console.log("final value", this.mortgageProviderValue);
        if (this.mortgageProviderValue) {
            this.prequalObj["mortgage_provider"] = this.mortgageProviderValue;
            this.util.setSessionStorage(this.prequalObj);
        }
        this.router.navigate(['../estimated_value_of_home'], { relativeTo: this._activatedRoute, queryParamsHandling: 'preserve' })
    }
}